/** @format */

export const navigationSlide = () => {
  const navSlideContainers = document.querySelectorAll('.navigation-slide');

  /**
   * Hides/displays products. Adds style to Navbar
   */
  const handleProductOptionClick = (
    productName: string,
    translateX: string,
    navButtonList: HTMLCollection,
    highlight: HTMLElement,
    productContainers: HTMLAllCollection
  ) => {
    if (highlight) {
      highlight.style.transform = `translateX(${translateX}rem)`;
    }

    // sets width of blue highlight for tab
    if (highlight) {
      switch (productName) {
        case 'truebeam-family':
          highlight.style.width = '24rem';
          break;
        case 'vitalbeam':
          highlight.style.width = '16rem';
          break;
        case 'halcyon-ethos':
          highlight.style.width = '20rem';
          break;
        case 'edge':
        case 'c-series':
          highlight.style.width = '12rem';
          break;
        default:
          highlight.style.width = '16.8rem';
          break;
      }
    }

    //  Hides/displays product containers.
    for (let i = 0; i < productContainers.length; i++) {
      if (
        navButtonList[i] &&
        productContainers[i].classList.contains(productName)
      ) {
        productContainers[i].classList.remove('hide');
        navButtonList[i].classList.add('active');
      } else if (navButtonList[i]) {
        productContainers[i].classList.add('hide');
        navButtonList[i].classList.remove('active');
      }
    }
  };

  /**
   * Iterates through each Navigation Slider.
   */
  navSlideContainers.forEach((element) => {
    const productContainers = document.querySelectorAll(
      `.${element.classList[1]} .nav-slide-product-container`
    );
    const navButtonList = document.querySelectorAll(
      `.${element.classList[1]} .nav-slide-container li`
    );
    const dropdownButton: HTMLElement | null = document.querySelector(
      `.${element.classList[1]} button`
    );
    const dropdownContainer = document.querySelector(
      `.${element.classList[1]}.nav-slide-dropdown-container ul`
    );
    const optionList = dropdownContainer?.querySelectorAll(`li`);
    const highlight: HTMLElement | null = document.querySelector(
      `.${element.classList[1]} .nav-option-backer`
    );

    // Toggles drop-down menu
    dropdownButton?.addEventListener('click', () => {
      dropdownContainer?.classList.toggle('hide');
      dropdownButton?.classList.toggle('arrow-open');
    });

    /**
     * Adds listener for each Product Button.
     */
    if (navButtonList) {
      Array.prototype.forEach.call(navButtonList, (button) => {
        const { translate, product } = button.dataset;
        button.addEventListener('click', () => {
          handleProductOptionClick(
            product,
            translate,
            navButtonList,
            highlight,
            productContainers
          );
        });
      });
    }

    /**
     * Adds listener for each Product Option.
     */
    if (optionList) {
      Array.prototype.forEach.call(optionList, (option) => {
        const { translate, product } = option.dataset;
        option.addEventListener('click', () => {
          handleProductOptionClick(
            product,
            translate,
            navButtonList,
            highlight,
            productContainers
          );
          dropdownContainer?.classList.toggle('hide');
          dropdownButton?.classList.toggle('arrow-open');
          dropdownButton.innerText = `${option?.innerHTML}`;
        });
      });
    }
  });
};
